import Const from "../const";

let color = {};
const skinType = Const.skinType.toUpperCase();

if (skinType === "GOGOIT") {
    color = {
        warn: '#1ECAD3',
        okButtonClassName: 'gogoit-antd-modal-ok-button-props',
        cancelButtonClassName: 'gogoit-antd-modal-cancel-button-props',
    }
} else {
    color = {
        warn: '',
        okButtonClassName: '',
        cancelButtonClassName: '',
    }
}
export default color;
